import React from 'react'
import Classes from '../../Forms.module.css'

export default function Sidebar({ activeTab, setActiveTab }) {
    return (
        <ul className={Classes.sidebar} >
            <li className={activeTab === "intake" ? Classes.active : ""}
                onClick={() => setActiveTab("intake")}>
                <h5>Intake</h5>
            </li>

            <li className={activeTab === "onboarding" ? Classes.active : ""}
                onClick={() => setActiveTab("onboarding")}>
                <h5>Onboarding</h5>
            </li>
        </ul>
    )
}
